<template>
	<div class="main-contents display">
		<div class="tit">
			<template>블로그 노출 <span v-if="blogSeq">수정</span><span v-else>등록</span></template><nbsp/>
			<img src="/images/admin/list_shortcut.png" alt="목록가기" @click="$router.go(-1)">
		</div>
		<div class="search-box btn">
			<div class="sub_btn dl" @click="delBanner()" v-if="blogSeq">삭제</div>
		</div>
		<!-- 블로그 노출 등록 -->
		<div class="banner_box">
			<div class="list">
				<div class="label">제목</div>
				<InputComp title="제목" v-model="data.blogTitle" rules="required"/>
			</div>
			<div class="list">
				<div class="label">개요</div>
				<InputComp title="개요" v-model="data.blogDtlDesc" rules="required"/>
			</div>
			<div class="list">
				<div class="label">노출기간</div>
				<SelectDate title="노출시작시간" tagNm="div" v-model="data.applyStartDate" type="HOUR" from="Y-10" to="Y10" rules="required"/>
				<p>~</p> 
				<SelectDate title="노출종료시간" tagNm="div" v-model="data.applyEndDate" type="HOUR" from="Y-10" to="Y10" rules="required"/>
			</div>
			<div class="list rank">
				<div class="label">노출순위</div>
				<SelectComp title="노출순위" v-model="data.displayOrd" list="1:1,2:2,3:3,4:4,5:5,6:6,7:7,8:8,9:9,10:10"/>
			</div>
			<div class="list">
				<div class="label">노출여부</div>
				<SelectComp title="노출여부" tagName="div" class="radio" type="radio" v-model="data.useYn" list="Y:노출,N:노출종료" rules="required"/>
			</div>
			<div class="list bn_img">
				<div class="label">블로그 이미지</div>
				<file-select title="블로그 이미지" tagNm="div" type="admin" v-model="temp.blogImg" :name="data.imgFileNm" accept=".jpg,.jpeg,.png,.bmp,.gif" rules="required"/>
				<p>※ 이미지 사이즈는 320 X 190 (픽셀)로 업로드 해 주세요.</p>
			</div>
			<div class="list link">
				<div class="label">링크 URL</div>
				<InputComp title="링크 URL" type="url" v-model="data.blogLinkUrl" rules="required"/>
				<p>※ URL 주소 앞에 절대주소(http://, https://)가 필수로 입력되어야 합니다.</p>
			</div>
		</div>
		<div class="select_btn">
			<div class="btn_01" @click="$router.go(-1)">취소</div>
			<div class="btn_02" @click="save()">적용</div>
		</div>
	</div>
</template>

<script>
import fileSelect from "@/components/FileSelect.vue";
export default {
	components: { fileSelect },
	data() {
		return {
			blogSeq: this.$route.query.blogSeq,

			data:{},
			temp: {},
		};
	},
	beforeMount(){
		if(this.blogSeq){
            this.$.httpPost('/api/main/bnr/getBlogInfo', {blogSeq:this.blogSeq})
                .then(res => {
                    this.data = res.data;
                }).catch(this.$.httpErrorCommon);
		}
	},
	methods : {
		save(){
			var files = [];
			if(this.temp.blogImg instanceof File){
				files.push(this.temp.blogImg);
                this.data.blogImgFileNm = this.temp.blogImg.name;
				this.data.blogImgFileYn = 'Y';
			}

			this.$.fileUpload('IMG', files, '/api/main/bnr/saveBlogInfo', this.data)
                .then(() => {
					alert('저장이 완료되었습니다.');
                    this.$router.go(-1);
                }).catch(this.$.httpErrorCommon);
		},
		delBanner(){
			var status = 'del'
			var list = [ this.data ];
			
			this.$.popup('/adm/man/MAN906P01', {list, status})
				.then(res => {
					if(res) {
						this.$router.go(-1);
					}
				});
			
		},
	}
}
</script>